// extracted by mini-css-extract-plugin
export default {"container":"SuccessPaymentPage_container__P+Ikw","icon":"SuccessPaymentPage_icon__xfD9E","formButton":"SuccessPaymentPage_formButton__g5x+T"};